import { lazy } from 'react';

// project import
import Loadable from 'layout/mantis/components/Loadable';
import GuestGuard from 'layout/mantis/utils/route-guard/GuestGuard';
import CommonLayout from 'layout/website/mantis';
// import SupportWrapper from 'modules/support/_partials/publicSupport/SupportWrapper';

const Page404 = Loadable(lazy(() => import('layout/mantis/pages/maintenance/404')));
const Page500 = Loadable(lazy(() => import('layout/mantis/pages/maintenance/500')));
const PageComingSoon = Loadable(lazy(() => import('layout/mantis/pages/maintenance/coming-soon')));
const PageUnderConstruction = Loadable(lazy(() => import('layout/mantis/pages/maintenance/under-construction')));

// render - login
const AuthLogin = Loadable(lazy(() => import('modules/oauth/login/LoginWrapper')));
const AuthRegister = Loadable(lazy(() => import('modules/oauth/Register/RegisterWrapper')));
const ForgetPasswordWrapper = Loadable(lazy(() => import('modules/oauth/forgetPassword/ForgetPasswordWrapper')));
const ResetPasswordWrapper = Loadable(lazy(() => import('modules/oauth/resetPassword/ResetPasswordWrapper')));
const EmailConfirmationWrapper = Loadable(lazy(() => import('modules/oauth/emailConfirmation/EmailConfirmationWrapper')));
const ForceResetPasswordWrapper = Loadable(lazy(() => import('modules/oauth/forceResetPassword/ForceResetPasswordWrapper')));
// const ForgetPassword = Loadable(lazy(() => import('modules/oauth/forgetPassword/ForgetPassword')));
/*const AuthForgotPassword = Loadable(lazy(() => import('layout/mantis/pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('layout/mantis/pages/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('layout/mantis/pages/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('layout/mantis/pages/auth/code-verification')));*/

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
	path: '/',
	children: [
		{
			path: '/',
			element: (
				<GuestGuard>
					<CommonLayout />
				</GuestGuard>
			),
			children: [
				{
					path: 'login',
					element: <AuthLogin />
				},
				{
					path: 'register',
					element: <AuthRegister />
				},
				// {
				// 	path: 'support/ticket',
				// 	element: <SupportWrapper />
				// },

				{
					path: 'forgot-password',
					element: <ForgetPasswordWrapper />
				},
				{
					path: 'force-reset-password',
					element: <ForceResetPasswordWrapper />
				},
				{
					path: 'reset-password/:token',
					element: <ResetPasswordWrapper />
				},
				{
					path: 'auth/email/verify/:id',
					element: <EmailConfirmationWrapper />
				},
				{
					path: '*',
					element: <Page404 />
				}
				/*{
					path: 'check-mail',
					element: <AuthCheckMail />
				},
				{
					path: 'reset-password',
					element: <AuthResetPassword />
				},
				{
					path: 'code-verification',
					element: <AuthCodeVerification />
				}*/
			]
		}
	]
};

export default LoginRoutes;
